import { IPaymentMethod } from './i-payment-method';

export interface IOffer {
  entityId: string;
  productId: string;
  name: string;
  type: string;
  images?: string[];
  productLocationPricing: IOfferLocationPricing[];
}

export interface IOfferLocationPricing {
  locationId: string;
  locationName: string;
  price: number;
  minimumOrderQuantity: number;
  maximumOrderQuantity: number;
  stockCount: number;
  enforceStockChecks: boolean;
  maximumAvailableOrderQuantity: number;
  minimumEstimatedDaysToDeliver: number;
  maximumEstimatedDaysToDeliver: number;
  paymentMethods: IPaymentMethod[];
}
